import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    maxWidth: "87%",
    margin: "0 auto",
    display: "block",
    width: "100%",
    ['@media (max-width: 992px)']: {
      maxWidth: "100%",
    },
  },
}));

const Form = (props) => {
  const classes = blockStyles();
  const { onSubmit } = props;

  const onFormSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  }
  
  const { className, children } = props;
  return (
    <form onSubmit = { onFormSubmit }
          className = { clsx(classes.root, className) } >
      { children }
    </form>
  );
};

export default Form;